import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as FB from '../firebase';

export const fetchAllUsers = createAsyncThunk('fetchAllUsers', async () => await FB.fetchAllUsers())

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    usersMap: {},
    loading: false
  },
  extraReducers: builder => {
    builder.addCase(fetchAllUsers.pending, state => {
      state.loading = true
    })
    builder.addCase(fetchAllUsers.fulfilled, (state, action) => {
      if (action.payload) {
        state.usersMap = action.payload
      }
      state.loading = false
    })
    builder.addCase(fetchAllUsers.rejected, state => {
      state.loading = false
      console.error('fetchAllUsers.rejected')
    })
  }
})

export default usersSlice
